<template>
  <div>
    <div class="grid_flex justify-space-between">
      <div class="detail_flex">
        <div class="mr-2">เลขที่ใบเสนอราคา</div>
        <div>{{ $props.quotation_code }}</div>
      </div>
      <div class="detail_flex">
        <div class="mr-2">วันที่เสนอราคา</div>
        <div>{{ $props.quotation_date }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "QuotationNumber",
  props: ['quotation_code', 'quotation_date']
}
</script>

<style scoped>
.grid_flex {
  display: flex;
}
.detail_flex {
  display: flex;
}
@media only screen and (max-width: 600px) {
  .grid_flex {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
    text-align: center;
  }
  .detail_flex {
    display: grid;
    grid-template-columns: 100%;
    text-align: center;
  }
}
</style>
